import { DefaultCustomItemOptions } from '@/components/documents/CustomItems/DefaultCustomItemOptions'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const UtahCustomItems = {
	...DefaultCustomItemOptions,
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceEmbalming]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceBodyPreparation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.BasicServicesOfFDAndStaffAdditional]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceFuneralMemorial]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceVisitationViewing]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationHearse]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationFamilyCarLimo]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseAckCards]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseMemorialFolders]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseMemorialBook]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseAlternativeContainer]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [],
		[PbSubcategory.Discount]: [],
	},
}
